import React from 'react';
import { Flex } from '@chakra-ui/core';
export default function RightChevron({
  fill,
  height,
  width,
  mb,
  ml,
  pb,
  mt,
  pt = 1,
  pr,
  pl
}) {
  return (
    <Flex ml={ml} mb={mb} mt={mt} pt={pt} pb={pb} pr={pr} pl={pl}>
      <svg width={width} height={height} viewBox="0 -4 1 21" fill="none">
        <path
          d="M5.07095 6.00009L1.24995 9.82109C0.835953 10.2351 0.835953 10.9071 1.24995 11.3211C1.66395 11.7351 2.33595 11.7351 2.74995 11.3211L7.36395 6.70709C7.75495 6.31609 7.75495 5.68309 7.36395 5.29309L2.74995 0.679092C2.33595 0.265093 1.66395 0.265093 1.24995 0.679092C0.835953 1.09309 0.835953 1.76509 1.24995 2.17909L5.07095 6.00009Z"
          fill={fill}
        />
      </svg>
    </Flex>
  );
}
